import { render, staticRenderFns } from "./assigned-objections-icon.vue?vue&type=template&id=01bc4952"
import script from "./assigned-objections-icon.vue?vue&type=script&lang=js"
export * from "./assigned-objections-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports